import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { userInitials, roleBadgeLabel } from '../api/auth';
import { ASSETS } from '../config/assets';
import { roleBadgeStyle } from '../utils/roleStyle';
export function PlanHeader({ sheetTitle, userRole, userEmail, userFullName, userFirstName, userLastName, userMenuOpen, onToggleUserMenu, onOpenProfile, onOpenAccess, onOpenAbout, onOpenDesignSystem, onLogout, }) {
    const initials = userInitials(userFirstName, userLastName);
    const displayName = userFullName || userEmail;
    const badge = roleBadgeLabel(userRole);
    return (_jsxs("div", { style: {
            height: 50,
            flex: 'none',
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '0 14px',
            background: '#FFFFFF',
            borderBottom: '1px solid #E2E8F0',
            position: 'relative',
            zIndex: 30,
        }, children: [_jsx("img", { src: ASSETS.logo, alt: "", style: { width: 28, height: 28 } }), _jsx("div", { style: { fontSize: 14.5, fontWeight: 700, letterSpacing: '-0.01em' }, children: "\u041A\u0432\u0430\u0440\u0442\u0430\u043B\u044C\u043D\u044B\u0439 \u043F\u043B\u0430\u043D" }), _jsx("div", { style: { width: 1, height: 20, background: '#E2E8F0' } }), _jsx("div", { style: { fontSize: 13.5, color: '#475569' }, children: sheetTitle }), _jsx("div", { style: { flex: 1 } }), _jsx("div", { style: roleBadgeStyle(userRole), children: badge }), _jsxs("div", { "data-menu-keep": "1", style: { position: 'relative' }, children: [_jsxs("button", { type: "button", onClick: onToggleUserMenu, className: "kp-user-btn", style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            border: 'none',
                            background: 'none',
                            cursor: 'pointer',
                            padding: '4px 6px',
                            borderRadius: 8,
                        }, children: [_jsx("span", { style: {
                                    width: 28,
                                    height: 28,
                                    borderRadius: '50%',
                                    background: '#DBEAFE',
                                    color: '#1D4ED8',
                                    fontSize: 11,
                                    fontWeight: 700,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }, children: initials }), _jsx("span", { style: { fontSize: 13, fontWeight: 500 }, children: displayName }), _jsxs("span", { style: { display: 'flex', flexDirection: 'column', gap: 3, width: 14, flex: 'none' }, children: [_jsx("span", { style: { height: 2, borderRadius: 1, background: '#64748B' } }), _jsx("span", { style: { height: 2, borderRadius: 1, background: '#64748B' } }), _jsx("span", { style: { height: 2, borderRadius: 1, background: '#64748B' } })] })] }), userMenuOpen ? (_jsxs("div", { "data-menu-keep": "1", style: {
                            position: 'absolute',
                            right: 0,
                            top: '100%',
                            marginTop: 4,
                            width: 224,
                            background: '#FFFFFF',
                            border: '1px solid #E2E8F0',
                            borderRadius: 10,
                            boxShadow: '0 8px 24px rgba(15,23,42,.14)',
                            padding: 6,
                            zIndex: 40,
                        }, children: [_jsxs("div", { style: { padding: '8px 10px' }, children: [_jsx("div", { style: { fontSize: 13, fontWeight: 600 }, children: displayName }), _jsx("div", { style: {
                                            fontSize: 12,
                                            color: '#64748B',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                        }, children: userEmail })] }), _jsx("div", { style: { height: 1, background: '#F1F5F9', margin: '4px 0' } }), _jsx("button", { type: "button", onClick: onOpenProfile, className: "kp-menu-btn", style: {
                                    width: '100%',
                                    textAlign: 'left',
                                    border: 'none',
                                    background: 'none',
                                    padding: '8px 10px',
                                    fontSize: 13,
                                    color: '#334155',
                                    cursor: 'pointer',
                                    borderRadius: 6,
                                }, children: "\u041F\u0440\u043E\u0444\u0438\u043B\u044C" }), _jsx("button", { type: "button", onClick: onOpenAccess, className: "kp-menu-btn", style: {
                                    width: '100%',
                                    textAlign: 'left',
                                    border: 'none',
                                    background: 'none',
                                    padding: '8px 10px',
                                    fontSize: 13,
                                    color: '#334155',
                                    cursor: 'pointer',
                                    borderRadius: 6,
                                }, children: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u0430" }), _jsx("button", { type: "button", onClick: onOpenAbout, className: "kp-menu-btn", style: {
                                    width: '100%',
                                    textAlign: 'left',
                                    border: 'none',
                                    background: 'none',
                                    padding: '8px 10px',
                                    fontSize: 13,
                                    color: '#334155',
                                    cursor: 'pointer',
                                    borderRadius: 6,
                                }, children: "\u041E \u043F\u0440\u043E\u0435\u043A\u0442\u0435" }), _jsx("button", { type: "button", onClick: onOpenDesignSystem, className: "kp-menu-btn", style: {
                                    width: '100%',
                                    textAlign: 'left',
                                    border: 'none',
                                    background: 'none',
                                    padding: '8px 10px',
                                    fontSize: 13,
                                    color: '#64748B',
                                    cursor: 'pointer',
                                    borderRadius: 6,
                                }, children: "\u0414\u0438\u0437\u0430\u0439\u043D-\u0441\u0438\u0441\u0442\u0435\u043C\u0430" }), _jsx("button", { type: "button", onClick: onLogout, className: "kp-danger-btn", style: {
                                    width: '100%',
                                    textAlign: 'left',
                                    border: 'none',
                                    background: 'none',
                                    padding: '8px 10px',
                                    fontSize: 13,
                                    color: '#B91C1C',
                                    cursor: 'pointer',
                                    borderRadius: 6,
                                }, children: "\u0412\u044B\u0439\u0442\u0438" })] })) : null] })] }));
}
